
$(document).ready(function(){
    var lastSettingTab = localStorage.getItem('lastSettingTab');

    if (lastSettingTab) $(`#${lastSettingTab}`).click();
    $('.nav-link').on('click', function() {
        localStorage.setItem('lastSettingTab', this.id);
    });
});
